import { createFileRoute } from '@tanstack/react-router';
import { OnboardStartPage } from '#src/pages/OnboardingPage/index.ts';

export const Route = createFileRoute('/{-$locale}/onboarding/_wrapper/')({
  component: RouteComponent
});

function RouteComponent() {
  return <OnboardStartPage />;
}
